import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=fc1831f6&scoped=true&"
import script from "./Field.vue?vue&type=script&lang=js&"
export * from "./Field.vue?vue&type=script&lang=js&"
import style0 from "./Field.vue?vue&type=style&index=0&id=fc1831f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1831f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fc1831f6', component.options)
    } else {
      api.reload('fc1831f6', component.options)
    }
    module.hot.accept("./Field.vue?vue&type=template&id=fc1831f6&scoped=true&", function () {
      api.rerender('fc1831f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Field/Field.vue"
export default component.exports